import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useState } from "react"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import {
  OrderCrudProvider,
  useOrderCrudContext,
} from "@/context/orderCrudContext"

export default function PurchaseList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Purchases</h5>
      </div>

      <OrderCrudProvider>
        <PurchaseTable />
      </OrderCrudProvider>
    </>
  )
}

function PurchaseTable() {
  const { openOrderDialog, setOpenOrderDialog, setSelectedOrderRow } =
    useOrderCrudContext()

  return (
    <>
      <CustomTable
        label="Purchase"
        columns={columns}
        apiPath="purchase"
        onAdd={() => setOpenOrderDialog(true)}
        onEdit={(rowData) => {
          setSelectedOrderRow(rowData)
          setOpenOrderDialog(true)
        }}
        onImport={true}
        onExport={true}
      />

      {openOrderDialog ? <Modal /> : null}
    </>
  )
}
